import FormGroup from "legacy/FormGroup"
import { centsToDollars, isNum } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class AdjustmentSection extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showAdjustmentForm: false,
      adjustmentButtonText: "Add Fee",
    }
    this.toggleAdjustmentForm = this.toggleAdjustmentForm.bind(this)
    this.openAdjustmentForm = this.openAdjustmentForm.bind(this)
    this.resetAdjustmentForm = this.resetAdjustmentForm.bind(this)
  }

  shouldShowAdjustmentOption() {
    if (isNum(this.props.newPrice) && isNum(this.props.currentPrice)) {
      return this.props.newPrice < this.props.currentPrice
    }
    return false
  }

  costDifference() {
    if (isNum(this.props.newPrice) && isNum(this.props.currentPrice)) {
      return Math.abs(this.props.newPrice - this.props.currentPrice)
    }
    return 0
  }

  toggleAdjustmentForm() {
    if (this.state.showAdjustmentForm) {
      this.resetAdjustmentForm()
    } else {
      this.openAdjustmentForm()
    }
  }

  openAdjustmentForm() {
    this.setState({
      showAdjustmentForm: true,
      adjustmentButtonText: "Reset Fee",
    })
  }

  resetAdjustmentForm() {
    this.props.resetAdjustment()
    this.setState({
      showAdjustmentForm: false,
      adjustmentButtonText: "Add Fee",
    })
  }

  adjustmentForm() {
    if (!this.state.showAdjustmentForm) {
      return null
    }

    return (
      <div className="row form-row bs-pt-4">
        <div className="col-sm-6">
          <FormGroup
            inputType="currency"
            label="Fee Amount"
            name="adjustmentAmount"
            value={this.props.adjustmentAmount}
            onChange={this.props.handleAdjustmentChange}
            validation={this.props.validator.message(
              "fee amount",
              this.props.adjustmentAmount,
              `min:0,num|max:${this.costDifference() / 100.0},num`
            )}
          />
        </div>
        <div className="col-sm-6">
          <FormGroup
            label="Description"
            name="adjustmentDescription"
            value={this.props.adjustmentDescription}
            onChange={this.props.handleInputChange}
            validation={this.props.validator.message(
              "fee description",
              this.props.adjustmentDescription,
              "required"
            )}
          />
        </div>
      </div>
    )
  }

  render() {
    this.props.validator.purgeFields()
    if (this.shouldShowAdjustmentOption()) {
      return (
        <div>
          <hr />
          <div className="row form-row">
            <div className="col-sm-8">
              <div>
                This will reduce the {this.props.resourceName} price by{" "}
                {centsToDollars(this.costDifference())}. Would you like to
                charge the boater a fee?
              </div>
            </div>
            <div className="col-sm-4">
              <button
                type="button"
                className="btn btn-secondary btn-sm w-full"
                onClick={this.toggleAdjustmentForm}
              >
                {this.state.adjustmentButtonText}
              </button>
            </div>
          </div>
          {this.adjustmentForm()}
        </div>
      )
    }
    return <div />
  }
}

AdjustmentSection.propTypes = {
  adjustmentAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  adjustmentDescription: PropTypes.string,
  currentPrice: PropTypes.number,
  handleAdjustmentChange: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  isCalculating: PropTypes.bool,
  newPrice: PropTypes.number,
  resetAdjustment: PropTypes.func.isRequired,
  resourceName: PropTypes.string.isRequired,
  validator: PropTypes.object.isRequired,
}

export default AdjustmentSection
